import React from "react";
import { Badge, formatTimeDate } from "@";
import type { ColumnDef } from "@tanstack/react-table";
import type { CampaignRecipient } from "../types";
import { RecipientStatus } from "../types";

interface StatusInfo {
  title: string;
  color: string;
}

const recipientStatusMap: Record<RecipientStatus, StatusInfo> = {
  [RecipientStatus.Queued]: { title: "في الانتظار", color: "yellow" },
  [RecipientStatus.Sent]: { title: "تم الإرسال", color: "green" },
  [RecipientStatus.Failed]: { title: "فشل", color: "red" },
};

export const recipientColumns: ColumnDef<CampaignRecipient>[] = [
  {
    id: "userName",
    header: "اسم المستخدم",
    accessorFn: ({ userName }) => userName || "-",
  },
  {
    id: "phoneNumber",
    header: "رقم الهاتف",
    accessorFn: ({ phoneNumber }) => phoneNumber || "-",
  },
  {
    id: "status",
    header: "الحالة",
    cell: ({ row }) => {
      const status = row.original.status;
      const statusInfo = recipientStatusMap[status] || {
        title: "غير معروف",
        color: "gray",
      };
      return <Badge title={statusInfo.title} color={statusInfo.color} />;
    },
  },
  {
    id: "sentAt",
    header: "تاريخ الإرسال",
    cell: ({ row }) =>
      row.original.sentAt ? formatTimeDate(row.original.sentAt) : "-",
  },
  {
    id: "failureReason",
    header: "سبب الفشل",
    accessorFn: ({ failureReason }) =>
      failureReason && failureReason.length > 50
        ? failureReason.slice(0, 50) + "..."
        : failureReason || "-",
  },
];
